import Overview from '../overview'
import EmptyPage from '../empty-page/EmptyPage'
import globals from '../../utils/globals'
import { h } from 'preact'
import { getSpamContent } from '../../services/spamService'
import UserCell from '../overview/cells/UserCell'
import DateCell from '../overview/cells/DateCell'
import SpamPostCell from '../overview/cells/SpamPostCell'
import { Message } from '../ui-components/Message'

const SpamOverview = () => {
  function getColumns () {
    return [
      {
        header: 'Post',
        size: 'xl',
        cell: (props: any) => <SpamPostCell {...props} />
      },
      { header: 'Published in', cell: ({ category } : { category: { name: string } }) => category && category.name },
      { header: 'Author', cell: UserCell('author') },
      { header: 'Publish date', cell: DateCell('createdAt') }
    ]
  }

  return <Overview
    type='spam'
    headerTitle='Spam'
    withPagination={{
      page: 1,
      pageSize: 25
    }}
    rowId='topicId'
    model={getColumns()}
    dataSource={getSpamContent}
    dataKey='result'
    EmptyStateComponent={<EmptyPage
      img_src={`${globals('defaultCdn')}/images/empty_page.png`}
      header='There is no spam yet'
      text=''
    />}
    message={<Message text='This overview shows a queue of idea and product update posts that have been automatically or manually marked as spam.' fullWidth />}
  />
}

export default SpamOverview
